{
  "pt": {
    "issue_status": {
      "actions": {
        "create": "Criar status de reclamação"
      },
      "labels": {
        "customer_status": "O cliente verá",
        "internal_status": "Estado interno",
        "new_issue_status": "Estado"
      }
    }
  }
}